import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil } from 'rxjs';
import { LoadingBarService } from '@app/shared/services/local/loading-bar/loading-bar.service';
import { Router } from '@angular/router';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingBarService = inject(LoadingBarService);
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loadingBarService.start();
    return next.handle(request.clone()).pipe(
      takeUntil(this.router.events),
      finalize(() => {
        setTimeout(() => {
          this.loadingBarService.complete();
        }, 200);
      }),
    );
  }
}
